import { SvgIcon, SvgIconProps } from '@mui/material'
import React from 'react'

export const ArrowDown:React.FC<SvgIconProps> = (props) => (
  <SvgIcon width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path d="M6 9L12 15L18 9" stroke="currentColor" fill="transparent" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
  </SvgIcon>
)
